import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
    connect() {
        const option = {
            hideSelected: true,
            allowEmptyOption: true,
            render: {
                option_create: (data, escape) =>
                    '<div class="create">Ajouter <strong>' + escape(data.input) + '</strong></div>',
                no_results: (data, escape) =>
                    '<div class="no-results">Aucun resultat trouve pour <strong>' +
                    escape(data.input) +
                    '</strong></div>',
            },
        };

        if (this.element.hasAttribute('create_tomselect')) {
            option.create = true;
        }

        this.tomSelect = new TomSelect(this.element, option);

        window.tomSelectLoaded = new Promise((resolve) => {
            setTimeout(() => resolve('TomSelect is ready!'), 500);
        });
    }

    disconnect() {
        this.tomSelect?.destroy();
    }
}
